import * as RealEstate from "../services/RealEstateService";

export const deleteLandById = async (id, access_token) => {
  const res = await RealEstate.DeleteRealEstate(id, access_token);
  return res;
};
